import { registerEventHandlers } from "/events";
import { eventHandlers as captchaEventHandlers } from "/modules/captcha";

import "/services/auth";

import "/modules/signup-social-toggle";
import "/modules/auth-popup";

registerEventHandlers([
  captchaEventHandlers
]);
